module.exports = __webpack_public_path__ + "static/media/Doklad_DVI_22.05.2018.047fc680.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Doklad_DVI_22.05.2018.pdf
// module id = 137
// module chunks = 0